<h1 class="accent-background-element">Review Edit Clinic/Office</h1>

<mat-dialog-content>
  <h3 [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.countryId!=editedClinicOffice?.countryId )}">Country:
    <span class="not-bold">{{getFullCountryName(editedClinicOffice?.countryId)}}</span>
  </h3>
  <h3 [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.shown!=editedClinicOffice?.shown )}">Show on the map:
    <span class="not-bold">{{editedClinicOffice?.shown? 'Yes':'No'}}</span>
  </h3>
  <h3 [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.type1!=editedClinicOffice?.type1 )}">Type 1: <span
  class="not-bold">{{getFullType1(editedClinicOffice?.type1)}}</span></h3>
  <h3 [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.shopType!=editedClinicOffice?.shopType )}">Type 2: <span
  class="not-bold">{{editedClinicOffice?.shopType |titlecase}}</span></h3>
  <h3 [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.clinicOfficeId!=editedClinicOffice?.clinicOfficeId )}">
    Clinic / Office ID: <span class="not-bold">{{editedClinicOffice?.clinicOfficeId}}</span></h3>
    <h3 [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.name!=editedClinicOffice?.name )}">Name: <span
    class="not-bold">{{editedClinicOffice?.name}}</span></h3>
    <h3 [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.email!=editedClinicOffice?.email )}">E-mail: <span
    class="not-bold">{{editedClinicOffice?.email}}</span></h3>
    <h3 [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.phone!=editedClinicOffice?.phone )}">Phone: <span
    class="not-bold">{{editedClinicOffice?.phone}}</span></h3>
    @if (isOffice) {
      <h3
        [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.website!=editedClinicOffice?.website )}">Website: <span
      class="not-bold">{{editedClinicOffice?.website}}</span></h3>
    }
    @if (!isOffice) {
      <h3 [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.brand!=editedClinicOffice?.brand )}">
        Brand ID: <span
      class="not-bold">{{editedClinicOffice?.brand?getBrandName(editedClinicOffice?.brand!):''}}</span></h3>
    }

    @if (isUs) {
      <h3 [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.crmType!=editedClinicOffice?.crmType )}">
        CRM: <span class="not-bold">{{editedClinicOffice?.crmType
      ?getCRMNameByNumber(editedClinicOffice?.crmType!):''}}</span></h3>
    }

    @if (isPhysical) {
      <h3
        [ngClass]="{ 'warn-text-element' :(compareLocation(currentClinicOffice?.geolocation,editedClinicOffice?.geolocation ))}">
        Coordinates: <span class="not-bold">{{editedClinicOffice?.geolocation?.latitude}},
      {{editedClinicOffice?.geolocation?.longitude}}</span></h3>
    }
    @if (isPhysical) {
      <h3 [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.city!=editedClinicOffice?.city )}">
        City: <span class="not-bold">{{editedClinicOffice?.city}}</span></h3>
      }
      @if (isPhysical) {
        <h3
          [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.addressLine1!=editedClinicOffice?.addressLine1 )}">
          Address Line 1: <span class="not-bold">{{editedClinicOffice?.addressLine1}}</span></h3>
        }
        @if (isPhysical) {
          <h3
            [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.addressLine2!=editedClinicOffice?.addressLine2 )}">
            Address Line 2: <span class="not-bold">{{editedClinicOffice?.addressLine2}}</span></h3>
          }
          @if (isPhysical) {
            <h3
              [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.zipCode!=editedClinicOffice?.zipCode )}">Zip Code: <span
            class="not-bold">{{editedClinicOffice?.zipCode}}</span></h3>
          }

          @if (isUs && editedClinicOffice && editedClinicOffice.state) {
            <h3 [ngClass]="{ 'warn-text-element' :(currentClinicOffice?.state!=editedClinicOffice.state )}">State:
              <span class="not-bold">{{getStateName(editedClinicOffice.state)}}</span>
            </h3>
          }

          @if (isPhysical && !isOffice) {
            <h3>Opening Hours: </h3>
          }
          @if (isPhysical && !isOffice) {
            <div class="hours">
              <p
                [ngClass]="{ 'warn-text-element' :(!currentClinicOffice?.openingHours || !editedClinicOffice?.openingHours || !isSameArray(currentClinicOffice?.openingHours![0],editedClinicOffice?.openingHours![0]))}">
                Monday:&nbsp; <span>{{(editedClinicOffice?.openingHours &&editedClinicOffice?.openingHours![0].length>0) ?
              editedClinicOffice?.openingHours![0].join(', '):"Closed"}}</span></p>
              <p
                [ngClass]="{ 'warn-text-element' :(!currentClinicOffice?.openingHours || !editedClinicOffice?.openingHours || !isSameArray(currentClinicOffice?.openingHours![1],editedClinicOffice?.openingHours![1]))}">
                Tuesday:&nbsp; <span>{{(editedClinicOffice?.openingHours &&editedClinicOffice?.openingHours![1].length>0) ?
              editedClinicOffice?.openingHours![1].join(', '):"Closed"}}</span></p>
              <p
                [ngClass]="{ 'warn-text-element' :(!currentClinicOffice?.openingHours || !editedClinicOffice?.openingHours || !isSameArray(currentClinicOffice?.openingHours![2],editedClinicOffice?.openingHours![2]))}">
                Wednesday:&nbsp; <span>{{(editedClinicOffice?.openingHours &&editedClinicOffice?.openingHours![2].length>0)
              ? editedClinicOffice?.openingHours![2].join(', '):"Closed"}}</span></p>
              <p
                [ngClass]="{ 'warn-text-element' :(!currentClinicOffice?.openingHours || !editedClinicOffice?.openingHours || !isSameArray(currentClinicOffice?.openingHours![3],editedClinicOffice?.openingHours![3]))}">
                Thursday:&nbsp; <span>{{(editedClinicOffice?.openingHours &&editedClinicOffice?.openingHours![3].length>0) ?
              editedClinicOffice?.openingHours![3].join(', '):"Closed"}}</span></p>
              <p
                [ngClass]="{ 'warn-text-element' :(!currentClinicOffice?.openingHours || !editedClinicOffice?.openingHours || !isSameArray(currentClinicOffice?.openingHours![4],editedClinicOffice?.openingHours![4]))}">
                Friday:&nbsp; <span>{{(editedClinicOffice?.openingHours &&editedClinicOffice?.openingHours![4].length>0) ?
              editedClinicOffice?.openingHours![4].join(', '):"Closed"}}</span></p>
              <p
                [ngClass]="{ 'warn-text-element' :(!currentClinicOffice?.openingHours || !editedClinicOffice?.openingHours || !isSameArray(currentClinicOffice?.openingHours![5],editedClinicOffice?.openingHours![5]))}">
                Saturday:&nbsp; <span>{{(editedClinicOffice?.openingHours &&editedClinicOffice?.openingHours![5].length>0) ?
              editedClinicOffice?.openingHours![5].join(', '):"Closed"}}</span></p>
              <p
                [ngClass]="{ 'warn-text-element' :(!currentClinicOffice?.openingHours || !editedClinicOffice?.openingHours || !isSameArray(currentClinicOffice?.openingHours![6],editedClinicOffice?.openingHours![6]))}">
                Sunday:&nbsp; <span>{{(editedClinicOffice?.openingHours &&editedClinicOffice?.openingHours![6].length>0) ?
              editedClinicOffice?.openingHours![6].join(', '):"Closed"}}</span></p>
            </div>
          }

          @if (isOffice) {
            <div>
              <h3>ENT Names: </h3>
              @if (editedClinicOffice?.doctors && editedClinicOffice?.doctors!.length>0) {
                <div class="doctors" >
                  @for (doctor of editedClinicOffice!.doctors; track doctor; let i = $index) {
                    <p  [ngClass]="{ 'warn-text-element' :(!currentClinicOffice?.doctors || !editedClinicOffice?.doctors || !isSameArray(currentClinicOffice?.doctors!,editedClinicOffice?.doctors!))}">
                      {{i+1}}.&nbsp;{{doctor}}
                    </p>
                  }
                </div>
              } @else {
                <mat-icon svgIcon='dash'></mat-icon>
              }
            </div>
          }
        </mat-dialog-content>

        <mat-dialog-actions>
          <span class="spacer"></span>
          <button mat-raised-button color="accent" (click)="onSubmit()">Continue</button>
        </mat-dialog-actions>



